<template>
    <div style="background-color: #FFFFFFFF;">
        <div class="floor3" data-aos="fade-up">
            <div>
                <div style="font-weight: bold; font-size: 32px; color: #222222;padding-top: 80px;margin-bottom:6px;">
                    云业务 · 智能驱动未来
                </div>
                <div style="font-size: 16px; color: #595859; line-height: 21px; margin-bottom: 10px;">
                    20个核心产品，打造160+场景 </div>
            </div>


            <div class="card-container" style="margin-top: 50px;">
                <div class="title">零售云</div>
                <div class="card-row">
                    <div class="card" @click="$router.push({ name: 'retailMall' })">
                        <div class="card-head">
                            <div class="icon-wrapper">
                                <img class="icon-normal" src="@/assets/home/floor3-new/icon1.svg" />
                                <img class="icon-hover" src="@/assets/home/floor3-new/icon1-1.svg" />
                            </div>
                            <div class="title1">千橙收银系统</div>
                        </div>
                        <div class="subtitle">AI驱动半自动/自助收单，智能识别交易场景，提升收银效率与体验。</div>
                        <img class="card-arow" src="@/assets/home/floor3-new/card-arrow.png">
                        <img class="card-bg" src="@/assets/home/floor3-new/card-bg.png">
                    </div>
                    <div class="card" @click="$router.push({ name: 'onlineAndOfflineIntegration' })">
                        <div class="card-head">
                            <div class="icon-wrapper">
                                <img class="icon-normal" src="@/assets/home/floor3-new/icon2.svg" />
                                <img class="icon-hover" src="@/assets/home/floor3-new/icon2-1.svg" />
                            </div>
                            <div class="title1">千橙门店O2O系统</div>
                        </div>
                        <div class="subtitle">AI赋能门店O2O一体化管理，智能匹配流量，高效协同线上线下业务。</div>
                        <img class="card-arow" src="@/assets/home/floor3-new/card-arrow.png">
                        <img class="card-bg" src="@/assets/home/floor3-new/card-bg.png">
                    </div>
                    <div class="card" @click="$router.push({ name: 'onlineErp' })">
                        <div class="card-head">
                            <div class="icon-wrapper">
                                <img class="icon-normal" src="@/assets/home/floor3-new/icon3.svg" />
                                <img class="icon-hover" src="@/assets/home/floor3-new/icon3-1.svg" />
                            </div>
                            <div class="title1">千橙连锁系统</div>
                        </div>
                        <div class="subtitle">AI赋能多业态连锁管理，智能数据分析预警，实现精细化运营管控。</div>
                        <img class="card-arow" src="@/assets/home/floor3-new/card-arrow.png">
                        <img class="card-bg" src="@/assets/home/floor3-new/card-bg.png">
                    </div>


                </div>
            </div>

            <div style="display: flex ;flex-direction: row;width: 1200px;margin: 20px auto;">
                <div class="card-container" style="width: 780px;">
                    <div class="title">分销云</div>
                    <div class="card-row">
                        <div class="card" @click="$router.push({ name: 'integration' })">
                            <div class="card-head">
                                <div class="icon-wrapper">
                                    <img class="icon-normal" src="@/assets/home/floor3-new/icon4.svg" />
                                    <img class="icon-hover" src="@/assets/home/floor3-new/icon4-1.svg" />
                                </div>
                                <div class="title1">千橙S2B2C系统</div>
                            </div>
                            <div class="subtitle">AI全链路闭环交易，智能撮合供需，自动化流转结算，助力产业协同。</div>
                            <img class="card-arow" src="@/assets/home/floor3-new/card-arrow.png">
                            <img class="card-bg" src="@/assets/home/floor3-new/card-bg.png">
                        </div>
                        <div class="card" @click="$router.push({ name: 'b2bChannel' })">
                            <div class="card-head">
                                <div class="icon-wrapper">
                                    <img class="icon-normal" src="@/assets/home/floor3-new/icon5.svg" />
                                    <img class="icon-hover" src="@/assets/home/floor3-new/icon5-1.svg" />
                                </div>
                                <div class="title1">千橙B2B系统</div>
                            </div>
                            <div class="subtitle">AI驱动多层级分销，智能定价与库存预警，实现全流程数字化提效。</div>
                            <img class="card-arow" src="@/assets/home/floor3-new/card-arrow.png">
                            <img class="card-bg" src="@/assets/home/floor3-new/card-bg.png">
                        </div>
                    </div>
                </div>

                <div class="card-container" style="width: 400px;">
                    <div class="title">会员云</div>
                    <div class="card-row">
                        <div class="card" @click="$router.push({ name: 'marketing' })">
                            <div class="card-head">
                                <div class="icon-wrapper">
                                    <img class="icon-normal" src="@/assets/home/floor3-new/icon6.svg" />
                                    <img class="icon-hover" src="@/assets/home/floor3-new/icon6-1.svg" />
                                </div>
                                <div class="title1">千橙会员营销系统</div>
                            </div>
                            <div class="subtitle">基于AI的会员SCRM，智能画像分群，个性化触达，提升全生命周期价值。</div>
                            <img class="card-arow" src="@/assets/home/floor3-new/card-arrow.png">
                            <img class="card-bg" src="@/assets/home/floor3-new/card-bg.png">
                        </div>



                    </div>
                </div>
            </div>

             <div style="display: flex ;flex-direction: row;width: 1200px;margin: 20px auto;">
                <div class="card-container" style="width: 780px;">
                    <div class="title">电商云</div>
                    <div class="card-row">
                        <div class="card" @click="$router.push({ name: 'digitalSystem' })">
                            <div class="card-head">
                                <div class="icon-wrapper">
                                    <img class="icon-normal" src="@/assets/home/floor3-new/icon7.svg" />
                                    <img class="icon-hover" src="@/assets/home/floor3-new/icon7-1.svg" />
                                </div>
                                <div class="title1">千橙微商城</div>
                            </div>
                            <div class="subtitle">AI社群电商小程序，智能商品推荐，场景化营销，助力私域流量高效变现。</div>
                            <img class="card-arow" src="@/assets/home/floor3-new/card-arrow.png">
                            <img class="card-bg" src="@/assets/home/floor3-new/card-bg.png">
                        </div>
                        <div class="card" @click="$router.push({ name: 'scrmProduct' })">
                            <div class="card-head">
                                <div class="icon-wrapper">
                                    <img class="icon-normal" src="@/assets/home/floor3-new/icon8.svg" />
                                    <img class="icon-hover" src="@/assets/home/floor3-new/icon8-1.svg" />
                                </div>
                                <div class="title1">汇团团社群营销系统</div>
                            </div>
                            <div class="subtitle">AI社群团购小程序，智能团长管理，自动化履约分佣，实现裂变增长。</div>
                            <img class="card-arow" src="@/assets/home/floor3-new/card-arrow.png">
                            <img class="card-bg" src="@/assets/home/floor3-new/card-bg.png">
                        </div>
                    </div>
                </div>

                <div class="card-container" style="width: 400px;">
                    <div class="title">直播云</div>
                    <div class="card-row">
                        <div class="card" @click="$router.push({ name: 'live' })">
                            <div class="card-head">
                                <div class="icon-wrapper">
                                    <img class="icon-normal" src="@/assets/home/floor3-new/icon9.svg" />
                                    <img class="icon-hover" src="@/assets/home/floor3-new/icon9-1.svg" />
                                </div>
                                <div class="title1">千橙Qlive直播</div>
                            </div>
                            <div class="subtitle">AI赋能直播系统，智能场控与数据复盘，优化流量转化，提升直播效能。</div>
                            <img class="card-arow" src="@/assets/home/floor3-new/card-arrow.png">
                            <img class="card-bg" src="@/assets/home/floor3-new/card-bg.png">
                        </div>
                    </div>
                </div>
            </div>

            <div style="height: 120px;"></div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            selectIndex: -1,
            serviceList: [
                {
                    name: 'S2B2b/B2B2b/B2b平台',
                    icon: require("@/assets/home/floor3/首页2-1.svg"),
                    iconsel: require("@/assets/home/floor3/首页2-1-hover.svg"),
                    desc: '全链路交易平台，分销订货系统',
                    subDesc: '分销订货系统多层级销售管理，代理分销、平台代发、服务商管理',
                    width: 0.5
                },
                {
                    name: 'B2B2C供销一体化',
                    icon: require("@/assets/home/floor3/首页2-2.svg"),
                    iconsel: require("@/assets/home/floor3/首页2-2-hover.svg"),
                    desc: '“商家入驻+平台自营”多运营模式',
                    subDesc: '供应商入驻，会员管理，在线结算账单，实现完整交易闭环',
                    width: 0.5
                },
                {
                    name: 'O2O线上线下一体化',
                    icon: require("@/assets/home/floor3/首页2-3.svg"),
                    iconsel: require("@/assets/home/floor3/首页2-3-hover.svg"),
                    desc: '线上电商与线下实体店完美结合',
                    subDesc: '平台入驻、LBS定位、门店分销、门店自提核销，线下体验线上购买',
                    width: 0.5
                },
                {
                    name: 'B2C零售商城',
                    icon: require("@/assets/home/floor3/首页2-4.svg"),
                    iconsel: require("@/assets/home/floor3/首页2-4-hover.svg"),
                    desc: '数字化突围，重塑零售品牌增长力',
                    subDesc: '统一后台管理，PC、APP、小程序、H5多终端适配',
                    width: 0.5
                },
                {
                    name: '全渠道电商ERP',
                    icon: require("@/assets/home/floor3/首页2-5.svg"),
                    iconsel: require("@/assets/home/floor3/首页2-5-hover.svg"),
                    desc: '全渠道一盘货、交付履约自动化',
                    subDesc: '全渠道ERP统一订单接入，提供标准化、自动化履约能力，实现各渠道业务高效、高质交付',
                    width: 0.5
                }, {
                    name: 'SCRM产品',
                    icon: require("@/assets/home/floor3/首页2-6.svg"),
                    iconsel: require("@/assets/home/floor3/首页2-6-hover.svg"),
                    desc: '智能匹配，数字化组织高效服务转化',
                    subDesc: '线索获取、流转、转化全节点在线，数字化用户与员工，实现服务精准匹配',
                    width: 0.5
                }, {
                    name: '智能客服系统',
                    icon: require("@/assets/home/floor3/首页2-7.svg"),
                    iconsel: require("@/assets/home/floor3/首页2-7-hover.svg"),
                    desc: '全面覆盖客户触点，统一接待',
                    subDesc: 'AI技术支撑，集成视频客服+文本/语音机器人+呼叫中心等 10大功能，全面提升客户满意度',
                    width: 0.5
                },

            ],
        };
    },

    methods: {

    },
};
</script>

<style lang="less" scoped>
.card-container {
    padding: 30px;
    width: 1200px;
    height: 264px;
    background: linear-gradient(180deg, #F0F6FF 0%, #FFFFFF 100%);
    border-radius: 15px;
    margin: 0 auto;
    // border: 1px solid transparent;
    transition: all 0.3s ease;

    &:hover {
        background: #FFFFFF;
        border-radius: 15px;
        border: none;
        position: relative;
        box-shadow: 0px 4px 20px rgba(122, 167, 255, 0.3);
        background: linear-gradient(180deg, #EAF3FF 0%, #FFFFFF 100%);
    }

    .title {
        font-weight: bold;
        font-size: 24px;
        color: #333333;
        line-height: 24px;
        text-align: justify;
    }

    .card-row {
        display: flex;
        flex-direction: row;
        margin-top: 30px;
        gap: 30px;

        .card {
            position: relative;
            background: #FFFFFF;
            box-shadow: 0px 2px 10px 0px rgba(10, 30, 69, 0.08);
            border-radius: 6px;
            padding: 23px 30px 30px 30px;
            cursor: pointer;

            &:hover {
                background: linear-gradient(142deg, #29B5FD 0%, #1C53FD 100%);
                box-shadow: inset 1px 0px 0px 0px #008CFF;
                border-radius: 6px;

                .title1 {
                    color: #FFFFFF;
                }

                .subtitle {
                    color: rgba(255, 255, 255, 0.8);
                }
            }

            .card-head {
                display: flex;
                flex-direction: row;
                align-items: center;

                .icon-wrapper {
                    position: relative;
                    width: 34px;
                    height: 34px;

                    img {
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 34px;
                        height: 34px;
                        transition: opacity 0.3s ease;
                    }

                    .icon-normal {
                        opacity: 1;
                    }

                    .icon-hover {
                        opacity: 0;
                    }
                }
            }

            &:hover {
                .icon-wrapper {
                    .icon-normal {
                        opacity: 0;
                    }

                    .icon-hover {
                        opacity: 1;
                    }
                }
            }


            .title1 {
                margin-left: 12px;
                font-weight: bold;
                font-size: 18px;
                color: #222222;
                line-height: 22px;
                text-align: left;
            }

            .subtitle {
                font-size: 14px;
                color: #595859;
                line-height: 20px;
                text-align: justify;
            }

            .card-arow {
                position: absolute;
                width: 20px;
                height: 20px;
                right: 20px;
                top: 30px;
            }

            .card-bg {
                position: absolute;
                width: 150px;
                height: 100px;
                right: 0px;
                bottom: 0px;
            }
        }
    }
}
</style>